const projectTypes = [
    {
        id: 1,
        title:'ФСНто-2008',
        description: "В сборник входит 228 позиций по техническому обслуживанию систем безопасности, включая системы охранно-пожарной сигнализации, автоматизированные системы  контроля и управления доступом, телевизионные системы охраны и наблюдения и оборудование общего назначения",
        dataUrl: './data/jrecords.json',
        data: [],
        gridHeader: [
            { title: "Шифр", field:"cipher", width:70, align:"center", headerSort:false },          
            { title:"Наименование", field:"title",  width:"600", align:"left", headerSort:false, formatter:"textarea"},
        ],
    },

    {
        id: 2,
        title:'Смета ТО по РТМ',
        description: 'Расчет сметной стоимости технического обслуживания на основании: РТМ 25 488-82 Министерства приборостроения, средств автоматизации и систем управления "Установки пожаротушения автоматические и установки пожарной, охранной и охранно-пожарной сигнализации. Нормативы численности персонала, занимающегося техническим обслуживанием и ремонтом"',
        dataUrl: './data/to-rtm.json',
        data: [],
        gridHeader: [
            { title: "Обоснование<br/>по РТМ 25.488-82", field:"cipher", width:120, align:"center", headerSort:false },          
            { title:"Наименование", field:"title",  width:"600", align:"left", headerSort:false, formatter:"textarea"},
        ],
    },

    {
        id: 3,
        title:'Смета по прейскуранту 2661 001-92',
        description: 'Расчет сметной стоимости технического обслуживания составлен в текущих ценах на основании прейскуранта  № 2661 001-92 МГО "Защита" - "Оптовые цены на техническое обслуживание и ремонт технических средств и систем пожаротушения, дымоудаления, охранной, пожарной и охранно-пожарной сигнализации"',
        dataUrl: './data/kurant2661.json',
        data: [],
        gridHeader: [
            { title: "Шифр по прейс-<br/>куранту<br/> 2661-001-92", field:"cipher", width:120, align:"center", headerSort:false },          
            { title:"Наименование оборудования<br/>по прейскуранту №2661-001-92", field:"title",  width:"600", align:"left", headerSort:false, formatter:"textarea"},
        ],
    },


    {
        id: 4,
        title:'Смета ТО + численность (МВД-2012)',
        description: 'Расчет численности персонала и сметной стоимости технического обслуживания по нормативам эксплуатации технических средств охраны, утвержденным приказами МВД РФ № 689 от 16.07.2012г (Приложение 2, раздел 1) и № 755 от 17.09.2005г (Приложение 3, раздел 3, п. 25.2)',
        dataUrl: './data/to-mvd.json',
        data: [],
        gridHeader: [
            { title: "Шифр", field:"cipher", width:70, align:"center", visible:false, headerSort:false },          
            { title:"Наименование", field:"title",  width:"600", align:"left", headerSort:false, formatter:"textarea"},
        ],
    }

];






export {projectTypes}
